import { Link } from "react-router-dom";
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Thank you — one careful letter, once a month.");
      setEmail("");
    } catch {
      toast.error("Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <footer className="mt-32 border-t border-[#E5E2DC] bg-[#F9F8F6]">
      <div className="max-w-[1360px] mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="eyebrow">The Newsletter</p>
          <h3 className="font-serif-display text-3xl sm:text-4xl mt-3 leading-none">
            One careful letter,<br/>once a month.
          </h3>
          <p className="text-[#5C5C5C] mt-4 max-w-md">
            Essays on attention, practice, and the interior life. No promotions, no noise, no unsubscribe pressure.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-lg">
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              data-testid="newsletter-email"
              placeholder="you@somewhere.com"
              className="flex-1 bg-white border border-[#E5E2DC] px-4 py-3 text-sm rounded-sm outline-none focus:border-[#2A3B32]"
            />
            <button data-testid="newsletter-submit" disabled={loading} className="btn-primary">
              {loading ? "Sending…" : "Subscribe"}
            </button>
          </form>
        </div>

        <div className="md:col-span-2">
          <p className="eyebrow mb-4">Read</p>
          <ul className="space-y-2 text-[15px]">
            <li><Link to="/catalog" className="link-underline">Catalog</Link></li>
            <li><Link to="/#featured" className="link-underline">Featured</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow mb-4">Account</p>
          <ul className="space-y-2 text-[15px]">
            <li><Link to="/login" className="link-underline">Sign in</Link></li>
            <li><Link to="/register" className="link-underline">Join</Link></li>
            <li><Link to="/library" className="link-underline">My Library</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-4">Studio</p>
          <p className="text-[15px] text-[#5C5C5C] leading-relaxed">
            Lucid Shelf is a small, independent publisher of self-development titles for readers who prefer depth to slogans.
          </p>
        </div>
      </div>
      <div className="border-t border-[#E5E2DC]">
        <div className="max-w-[1360px] mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-[12px] text-[#5C5C5C]">
          <p>© {new Date().getFullYear()} Lucid Shelf. All rights reserved.</p>
          <p className="tracking-[0.14em] uppercase">Made slowly</p>
        </div>
      </div>
    </footer>
  );
}
